// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2EHV-","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1H2eE"};